<template>
  <div class="popup animation_background">
    <div class="popup_panel animation_popup">
      <div class="container">
        <div class="header animation_header">
          <h2>テイクアウトのご利用について</h2>
          <button @click="dismissUsage" class="back" />
        </div>
        <ul>
          <li>テイクアウト注文は香の川製麺各店舗の店頭およびお電話にて承ります。</li>
          <li>一部店舗ではテイクアウト販売を行っておりません。</li>
          <li>注文数が多い場合や混雑時はお時間をいただく場合がございます。あらかじめご了承下さい。</li>
          <li>各店舗の営業時間内にご注文をお願いします。</li>
          <li>品切れの際はご了承下さい。</li>
          <li>専用容器に入れてお渡しします。</li>
          <li>電子レンジ使用時は、別の容器に移してください。加熱しすぎにご注意ください。</li>
          <li>栄養成分、アレルゲン情報につきましては、従業員へお問い合わせください。</li>
          <li>お買い上げ後はなるべくお早めにお召し上がり下さい。</li>
          <li>ライス大盛り無料サービスは一部メニュー（惣菜軽食、キッズ、デザート）を除きます。</li>
          <li>ライスからパンへの変更はできません。</li>
          <li>お米は全て国産米を使用しております。</li>
          <li>メニューや付け合せ等の一部が予告なく変更する場合がございます。</li>
          <li>店内飲食とテイクアウトでは消費税額が異なります。</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NetShopTakeOutUsage',
  data() {
    return {
      title: 'テイクアウトのご利用について'
    }
  },
  created() {
  },
  methods: {
    dismissUsage() {
      this.$emit('dismissUsage')
    }
  }
}
</script>

<style scoped lang="scss">
  .popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;

    .container {
      display: flex;
      flex-direction: column;
      align-items: center;
      align-content: space-around;
      border: 1px solid #eeeeee;
      border-radius: 12px;
      background-color: #ffffff;
      padding-top: 0;

      .header {
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        width: 80%;
        font-weight: bold;
        height: 44px;
        border-bottom: 1px solid #dddddd;
        border-radius: 14px 14px 0 0;
        background: #ffffff;

        h2 {
          font-size: 14px;
        }

        button.back {
          height: 44px;
          width: 44px;
          border: none;
          background: url("~@/assets/img/buttons/close.svg") no-repeat center;
          background-size: 14px;
          position: absolute;
          top: 0;
          right: 0;
        }
      }

      ul {
        font-size: 13px;
        text-align: left;
        padding-left: 15px;
        margin: 24px;
        margin-top: 68px;

        li {
          margin-bottom: 0.5em;
        }
      }
    }
  }

  .popup_panel {
    width: 80%;
    max-height: 80%;
    overflow: scroll;
    border-radius: 12px;
  }

  /* 背景表示のアニメーション */
  .animation_background {
    animation: fadeIn 0.4s ease normal 0s none running;
  }

  /* popupアニメーション */
  .animation_popup {
    animation: bounce 1s ease normal 0s none running;
    background: #ffffff;
  }

  .animation_header {
    animation: header 1s ease normal 0s none running;
  }

  @keyframes bounce {
    0%,
    100%,
    20%,
    50%,
    80% {
      transform: scale(1, 1);
    }
    40% {
      transform: scale(0.93, 0.93);
    }
    60% {
      transform: scale(0.98, 0.98);
    }
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes header {
    0% {
      width: 100%;
    }
    100% {
      width: 100%;
    }
  }
</style>
